/* eslint-disable */
import Vue from 'vue';
// singleton Map holding loaded externalcomponents
window.externalComponents = window.externalComponents || {};
// singleton holding external component map name:url

window.globalIndex = window.globalIndex || {};
window.browserCache = true;
window.loadingJobs = [];
window.blockLoadingStatus = window.blockLoadingStatus ? window.blockLoadingStatus : 'loading'; // ARTEFACT TO ENSURE COMPATIBILITY - REMOVE
async function sleep(time) {
	return new Promise((resolve) => {
		setTimeout(() => resolve(), time);
	});
}

function addLoadingJob(job) {
	window.blockLoadingStatus = 'loading'; // ARTEFACT TO ENSURE COMPATIBILITY - REMOVE
	window.loadingJobs.push(job);
}
function resolveLoadingJobs() {
	if (window.loadingJobs.find((job) => job.status === 'loading')) {
		return;
	}
	window.loadingJobs.forEach((job) => {
		const manifest = job.manifest;

		manifest.blocks.forEach((component) => {
			component.url = new URL(component.path, job.url).toString();

			if (window.globalIndex[component.name]) console.warn(`Warning component name dub ${component.name}`);
			window.globalIndex[component.name] = component;
		});
	});
	window.loadingJobs = [];
	window.blockLoadingStatus = 'loaded'; // ARTEFACT TO ENSURE COMPATIBILITY - REMOVE
}

export default {
	async import(url) {
		const job = {
			url,
			status: 'loading',
			manifest: null,
		};
		addLoadingJob(job);
		let response = await fetch(`${new URL('manifest.json', url)}?${Date.now()}`);
		if (response.status === 401 || response.status === 403) {
			response = await fetch(`${new URL('manifest.json', url)}?${Date.now()}`, {
				credentials: 'include',
			});
		}
		if (!response.ok) {
			job.status = 'error';
			throw Error(`Could not loader manifest.json from ${url} \nServer status: ${response.status}`);
		}
		let result;
		try {
			result = await response.json();
			job.status = 'loaded';
			job.manifest = result;
		} catch (error) {
			job.status = 'error';
			throw Error('Error parsing Manifest.json: ' + response.data);
		}
		resolveLoadingJobs();
	},
	async clearCache() {
		Object.keys(window.externalComponents).forEach(
			(componentName) => delete window.externalComponents[componentName]
		);
	},
	setBrowserCache(enable) {
		window.browserCache = enable;
	},
	async get(name) {
		// console.log('window.externalComponentLoading get:', name);

		while (window.loadingJobs.length !== 0) {
			await sleep(50);
		}
		if (window.externalComponents[name]) return window.externalComponents[name];

		if (!window.globalIndex[name]) throw new Error(`Unknown external component ${name}`);

		const url = `${window.globalIndex[name].url}${window.browserCache ? '' : `#${Date.now()}`}`;

		await new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.async = true;
			script.addEventListener('load', () => {
				// script loads the content into a global variable with a key part of the url
				const globalScriptKey = `_BLOCK_${name}`;
				// create and scope components Constructors
				window.externalComponents[name] = Vue.extend(window[globalScriptKey]);
				// delete window[globalScriptKey];
				// document.head.removeChild(script);
				resolve();
			});
			script.addEventListener('error', () => {
				reject(new Error(`Error loading ${url}`));
			});
			script.src = url;
			document.head.appendChild(script);
		});

		return window.externalComponents[name];
	},
};
